import { useEffect, useRef, useState } from 'react';
import { cn } from '@/lib/utils/cn';

interface ChallengeCountdownProps {
    countdownTime: string;
    className?: string;
}

export function ChallengeCountdown({ countdownTime, className }: ChallengeCountdownProps) {
    const [timeLeft, setTimeLeft] = useState('');
    const timerRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        const calculateTimeLeft = () => {
            const now = new Date().getTime();
            const endDate = new Date(countdownTime).getTime();
            const distance = endDate - now;

            if (distance < 0) {
                setTimeLeft('00:00:00');
                if (timerRef.current) {
                    clearInterval(timerRef.current);
                    timerRef.current = null;
                }
                return;
            }

            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            if (days > 0) {
                setTimeLeft(`${days}d ${hours}h ${minutes}m ${seconds}s`);
            } else {
                setTimeLeft(`${hours}h ${minutes}m ${seconds}s`);
            }
        };

        calculateTimeLeft();
        timerRef.current = setInterval(calculateTimeLeft, 1000);

        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
                timerRef.current = null;
            }
        };
    }, [countdownTime]);

    return (
        <div className={cn('w-[100px] text-[13px] leading-none lg:min-w-[150px] lg:text-base', className)}>
            {timeLeft}
        </div>
    );
}
